// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
    display: flex;
    justify-content: center;
    align-items: center;
    height:80vh;
}

.login-form .container {
    display: block;
    border-radius: 0.5rem;
    padding: 20px;
    width: 350px;
    border: 1px solid #dee2e6;
}

.dark {
    background-color: #2b3035;
}

.light {
    background-color: #f0efef;
}`, "",{"version":3,"sources":["webpack://./src/Components/Loginform/Loginform.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".login-form {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height:80vh;\r\n}\r\n\r\n.login-form .container {\r\n    display: block;\r\n    border-radius: 0.5rem;\r\n    padding: 20px;\r\n    width: 350px;\r\n    border: 1px solid #dee2e6;\r\n}\r\n\r\n.dark {\r\n    background-color: #2b3035;\r\n}\r\n\r\n.light {\r\n    background-color: #f0efef;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
